import { render } from "./Lightbox.vue?vue&type=template&id=1de07886&scoped=true&ts=true"
import script from "./Lightbox.vue?vue&type=script&lang=ts"
export * from "./Lightbox.vue?vue&type=script&lang=ts"

import "./Lightbox.vue?vue&type=style&index=0&id=1de07886&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de07886"]])

export default __exports__